// extracted by mini-css-extract-plugin
export default {"about_full_container":"About_about_full_container__b6YwJ","about_container":"About_about_container__XuTs-","about_content":"About_about_content__Lv4tg"};